module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  confirmationMessageDisabeld = showConfirmation? '': 'disabled'; 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Submit Data Settings</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex\">\r\n        <input type=\"checkbox\" name=\"showConfirmation\" id=\"showConfirmation\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Show success message</label>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <input type=\"text\" name=\"confirmationMessage\" value=\"")
    ; __append(escapeFn(confirmationMessage))
    ; __append("\" ")
    ; __append(escapeFn(confirmationMessageDisabeld))
    ; __append("/>\r\n    </div>\r\n</div>\r\n<div class=\"row prop-separator-radio\">\r\n    <div class=\"col-md-12 prop-sublabel nopadding-r form-group-flex\" style=\"width: 100%;\">\r\n        <input type=\"checkbox\" name=\"submitAsChildIfNoParent\" value=\"submitAsChildIfNoParent\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Submit as child even if parent is not submitted</label>\r\n    </div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}